const service = {
  serialNumber: {
    label: "Numéro de série",
  },
  orderNumber: {
    label: "Numéro de CMD"
  },
  terminationTicket: {
    label: "Ticket de résiliation"
  },
  quoteNumber: {
    label: "Numéro de devis"
  },
  productName: {
    label: "Nom du produit"
  },
  price: {
    label: "Prix"
  },
  state: {
    label: "Etat",
    options: {
      active: "Actif",
      inactive: "Inactif",
      termination: "En cours de résiliation",
      terminationWaiting: "En attente de résiliation",
      terminationScheduled: "Résiliation planifié",
      terminated: "Résilié",
    }
  },
  partner: {
    label: "Client"
  },
  client: {
    label: "Compte"
  },
  place: {
    label: "Site"
  },
  productFamily: {
    label: "Famille de produit"
  },
  productSubFamily: {
    label: "Sous-famille de produit"
  },
  deliveryDateTimeframe: {
    label: "Livraison"
  },
  deliveryDateMin: {
    label: "Date de livraison (min)"
  },
  deliveryDateMax: {
    label: "Date de livraison (max)"
  },
  updateDateTimeframe: {
    label: "MàJ"
  },
  updateDateMin: {
    label: "Date de MàJ (min)"
  },
  updateDateMax: {
    label: "Date de MàJ (max)"
  },
  contractEndAtExpectedMin: {
    label: "Date de FdC (min)"
  },
  contractEndAtExpectedMax: {
    label: "Date de FdC (max)"
  },
  contractTacitAgreement: {
    label: "Reconduction Tacite ?"
  },
  contracts: {
    label: "Contract"
  },
  amendments: {
    label: "Avenants"
  },
  relocation: {
    label: "Déménagements",
    state: {
      options: {
        applied: "Effectué",
        notApplied: "En attente"
      }
    }
  },
  emptyApiKey: {
    label: "Clé manquante"
  },
  consumptionDate: {
    label: "Date"
  },
  hasPhoneSystemReporting: {
    label: "Rapport système téléphonie?"
  },
  specificPhonePriceList: {
    label: ""
  },
  serviceSlave: {
    label: "Option"
  },
  centreonHost: {
    label: "Host Centreon"
  },
  centreonService: {
    label: "Service Centreon"
  },
  centreonConfigurations: {
    label: "Service Centreon #key#",
    allowMoreField: {
      addLabel: "Ajouter",
      removeLabel: "Enlever",
      removingLabel: "Supprimer"
    }
  },
  dataRechargeChoice: {
    label: "Recharge"
  },
  dataRechargeBill: {
    label: "Ne pas facturer"
  },
  simSwapNumber: {
    label: "Nouveau numéro SIM"
  },
  alphalinkUsedDataRecharge: {
    label: "Recharge",
    alphalinkState: {
      options: {
        done: "Livré",
        canceled: "Annulé",
        waiting: "En attente",
        delivery: "En cours de livraison",
      }
    },
    billed: {
      options: {
        done: "Terminé",
        notDone: "En attente"
      }
    }
  },
  transatelUsedDataRecharge: {
    label: "Recharge",
    transatelState: {
      options: {
        done: "Livré",
        canceled: "Annulé",
        waiting: "En attente",
        delivery: "En cours de livraison",
      }
    },
    billed: {
      options: {
        done: "Terminé",
        notDone: "En attente"
      }
    }
  },

  transition: {
    scheduleTermination: {
      scheduleDate: {
        label: "Date de livraison",
        invalid: {
          assertEmpty: "Veuillez choisir la date de livraison.",
        }
      }
    }
  }
};

export default service;
